import {Country} from 'services/entities/country';
import config from 'config';

export async function loadCountries(): Promise<Country[]> {
  const response = await fetch(config.countries.listURL);
  const countries: Country[] = await response.json();
  for(const c of countries) {
    c.flag = config.countries.flagsDir + c.flag;
  }
  return countries;
}